import { Component, Output, EventEmitter } from '@angular/core';
import { Card, StateService } from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent {
  collapsed = false;
  public subs: Subscription[] = [];

  public topMenu: Card[] = [
    {
      title: 'Start',
      icon: 'home-outline',
      subtitle: '',
      routerLink: '/mainview/home',
    },
    {
      title: 'Baustellen',
      icon: 'construct-outline',
      subtitle: '',
      routerLink: '/mainview/construction-sites',
    },
    /*{
      title: 'Kalender',
      icon: 'calendar-outline',
      subtitle: '',
      routerLink: '/mainview/calendar',
    },*/
    {
      title: 'Arbeitszeit',
      icon: 'time-outline',
      subtitle: '',
      routerLink: '/mainview/hours-overview',
    },
    {
      title: 'Bautagesberichte',
      icon: 'clipboard-outline',
      subtitle: '',
      routerLink: '/mainview/construction-day-report-overview',
    },
    {
      title: 'Abwesenheit',
      icon: 'sunny-outline',
      subtitle: '',
      routerLink: '/mainview/absence-overview',
    },
    /*{
      title: 'Fahrtenberichte',
      icon: 'speedometer-outline',
      subtitle: '',
      routerLink: '/mainview/trip-overview',
    },*/
    {
      title: 'Maschinenpark',
      icon: 'boat-outline',
      subtitle: '',
      routerLink: '/mainview/machinery-overview',
    },
    {
      title: 'Ablage',
      icon: 'folder-outline',
      subtitle: '',
      routerLink: '/mainview/files',
    },
    /*,
    {
      title: 'Rapportberichte',
      icon: 'document-text-outline',
      subtitle: '',
      routerLink: '/mainview/rapport-overview',
    },*/
  ];

  bottomMenu = [
    {
      title: 'Einstellungen',
      icon: 'settings-outline',
      subtitle: '',
      routerLink: '/mainview/settings',
    },
  ];

  constructor(private state: StateService) {}

  async ngOnInit(): Promise<void> {
    this.collapsed =
      (await this.state.readFromSecureStorage(this.state.SIDEBARCOLLAPSED)) ==
      '1';
    this.subs.push(
      this.state.usrType$.subscribe((x) => {
        if (this.state.isCompanyAdmin) {
          if (this.topMenu.find((x) => x.title == 'Mitarbeiter') == null) {
            this.topMenu.push({
              title: 'Mitarbeiter',
              icon: 'people-outline',
              subtitle: '',
              routerLink: '/mainview/user',
            });
          }
        }
      })
    );
  }

  logout() {
    this.state.logout();
  }

  async toggleSidebar() {
    this.collapsed = !this.collapsed;
    await this.state.saveToSecureStorage(
      this.state.SIDEBARCOLLAPSED,
      this.collapsed ? '1' : '0'
    );
  }
}
